import { getRGBA } from '../../utils/rgb';

import { Color, NonCssColor } from './colors';

const black = (a = 1) => getRGBA(0, 0, 0, a);
const white = (a = 1) => getRGBA(255, 255, 255, a);

export const DefaultColors = {
  [Color.Violet]: {
    violet450: '#6782BA',
  },
  [Color.Purple]: {
    purple450: '#C174AD',
    default: '#800080', //#800080
    CC_LIGHT_PURPLE: '#f9f2ff',
    CC_PURPLE: '#cdabe5',
    CC_ARROW_PURPLE: '#B485CC',
  },
  [Color.Red]: {
    red450: '#ED676A',
    default: '#FF0000', //#FF0000
    CC_LIGHT_RED: '#fff0f0',
    CC_RED: '#ffb3c4',
    CC_PINK: '#f8b0ca',
    WARNING_COLOR: '#d95141', //L55
    WARNING_BACKGROUND_COLOR: '#fd8080',
    MIDDLE_RED: '#ff8080',
    CC_ARROW_RED: '#F08080',
    CC_ARROW_PINK: '#F17AAE',
    CC_UNFILLED_PINK: '#E68AE6',
    CC_UNFILLED_LIGHT_PINK: '#FFE8FF',
    CC_GAME_GLOBAL_RED: '#ff5959',
  },
  [Color.Orange]: {
    orange450: '#EFB86E',
    default: '#FFA500', //#FFA500
    CC_LIGHT_ORANGE: '#fff3e6',
    CC_ORANGE: '#fab338',
    INSTRUCTION_COLOR: '#de771c',
    PLAY_ORANGE: '#f07935',
    DISCOUNT_COLOR: '#e59030',
    CC_ARROW_ORANGE: '#F9A623',
  },
  [Color.Yellow]: {
    yellow450: '#F7CC61',
    default: '#FFFF00', //#FFFF00
    CC_LIGHT_YELLOW: '#fffbe6',
    CC_YELLOW: '#ffe263',
    PROGRESS_YELLOW: '#f6ce45',
    CC_ARROW_YELLOW: '#FECB09',
  },
  [Color.Green]: {
    green450: '#98C466',
    default: '#008000', //#008000
    CC_LIGHT_GREEN: '#f0fff0',
    CC_GREEN: '#badf82',
    TITLE_COLOR: '#186c78',
    DARK_TITLE_COLOR: '#13656a',
    PROGRESS_GREEN: '#46cbc0',
    OPPONENT_GREEN: '#63d6c1',
    AQUAMARINE: '#6cf2da',
    CC_ARROW_GREEN: '#8ECC52',
  },
  [Color.Cyan]: {
    default: '#00FFFF', //#00FFFF
    DIPDIP_COLOR: '#34b9ae',
    DONE_COLOR: '#23a79c',
    CC_UNFILLED_CYAN: '#46CBC0',
    CC_UNFILLED_LIGHT_CYAN: '#DAF4F2',
    CC_DARY_CYAN: '#1a7075',
    CC_CYAN: '#298D92',
  },
  [Color.Blue]: {
    blue450: '#52B1D7',
    default: '#0000FF', //#0000FF
    CC_LIGHT_BLUE: '#e6ffff',
    CC_BLUE: '#8fd9fa',
    CC_DARK_BLUE: '#00b0a4',
    LINK_COLOR: '#00acfb',
    LIGHT_BLUE: '#008dd6',
    EXIT_BLUE: '#3292d9',
    OPPONENT_BLUE: '#45a8e6',
    CC_ARROW_LIGHT_BLUE: '#64CBFA',
    CC_UNFILLED_BLUE: '#80AAFF',
    CC_UNFILLED_LIGHT_BLUE: '#EBF5FF',
    LIGHT_GRAYISH_BLUE: '#d8dfed',
    VERY_DARK_GRAYISH_BLUE: '#485053',
  },
  [Color.White]: {
    default: white(),
    [0]: white(0),
    [10]: white(0.1),
    [15]: white(0.15),
    [20]: white(0.2),
    [25]: white(0.25),
    [30]: white(0.3),
    [40]: white(0.4),
    [50]: white(0.5),
    [60]: white(0.6),
    [70]: white(0.7),
    [75]: white(0.75),
    [80]: white(0.8),
    [85]: white(0.85),
    [90]: white(0.9),
  },
  [Color.Black]: {
    default: black(),
    [0]: black(0),
    [10]: black(0.1),
    [15]: black(0.15),
    [20]: black(0.2),
    [30]: black(0.3),
    [50]: black(0.5),
    [60]: black(0.6),
    [70]: black(0.7),
    [80]: black(0.8),
  },
  [Color.Gray]: {
    default: '#999999',
    DEFAULT_COLOR: '#333333', // default black (true black in app)
    GRAY_L90: '#E5E5E5',

    SWITCH_OFF_COLOR: '#E6E7E8',
    VERY_VERY_DARK_GRAY: '#1a1a1a',
    VERY_DARK_GRAY: '#606060',
    DARK_GRAY: '#6c6c6c',
    MIDDLE_GRAY: '#808080',
    BRIGHT_GRAY: '#b3b3b3',
    VERY_BRIGHT_GRAY: '#cccccc',
    VERY_BRIGHT_GRAY_50: '#cccccc50',
    VERY_VERY_BRIGHT_GRAY: '#f1f1f1',
    VERY_LIGHT_GRAY: '#f2f2f2',
    VERY_LIGHT_GRAY_80: '#f2f2f280',
    CURSED_GRAY: '#666666',
  },
  [NonCssColor.Medal]: {
    bronze: '#B36212',
    silver: '#77868C',
    gold: '#B38900',
    platinum: '#5B7699',
    jade: '#007A6B',
    carnelian: '#CC3900',
    ruby: '#A60070',
    amethyst: '#6B21A6',
    opal: '#B3249F',
    diamond: '#1B3BB3',
  },
  [NonCssColor.Clickable]: {
    dark_1: '#46cbc0',
    dark_1_disabled: '#46cbc0cc',
    dark_2: '#a8f0ea',
    dark_2_disabled: '#a8f0eacc',
    dark_3: '#abd1ce',
    dark_3_disabled: '#abd1cecc',

    light_1: '#34b9ae',
    light_1_disabled: '#34b9aecc',
    light_2: '#05656b',
    light_2_disabled: '#05656bcc',
    light_3: '#5d8e8f',
    light_3_disabled: '#5d8e8fcc',
  },
  [NonCssColor.Rainbow]: {
    CC_LIGHT_RED: '#fff0f0',
    CC_LIGHT_ORANGE: '#fff3e6',
    CC_LIGHT_YELLOW: '#fffbe6',
    CC_LIGHT_GREEN: '#f0fff0',
    CC_LIGHT_BLUE: '#e6ffff',
    CC_LIGHT_PURPLE: '#f9f2ff',
  },
  [NonCssColor.GameShowBubble]: {
    red: '#ed676a',
    earthy: '#efb86e',
    yellow: '#f7cc61',
    green: '#98c466',
    blue: '#52b1d7',
    indigo: '#6782ba',
    purple: '#c174ad',
  },
};

export const rainbowColorSetStroke450: string[] = [
  DefaultColors[Color.Red].red450,
  DefaultColors[Color.Orange].orange450,
  DefaultColors[Color.Yellow].yellow450,
  DefaultColors[Color.Green].green450,
  DefaultColors[Color.Blue].blue450,
  DefaultColors[Color.Violet].violet450,
  DefaultColors[Color.Purple].purple450,
];

export const colorForGameSetId = (uuid: string): string => {
  const segments = uuid.split('-');
  const segment = segments[2]; // Taking the third segment

  // Check if the segment is defined and parse it, otherwise default to the first color
  const index = segment
    ? parseInt(segment, 16) % rainbowColorSetStroke450.length
    : 0;
  return rainbowColorSetStroke450[index] ?? DefaultColors[Color.Red].red450;
};

export const strokeColors: [string, string][] = [
  ['#EB4D4D', '#FBDCDC'],
  ['#86BA4B', '#E7F1D8'],
  ['#B65C9F', '#F1DEEC'],
  ['#E0B300', '#F9F1CA'],
  ['#4C6CAE', '#DBE1F0'],
  ['#EB8C36', '#FCE8D3'],
  ['#34A3D0', '#D4ECF7'],
  ['#CC3E6D', '#F6D8E2'],
  ['#99991F', '#EBEBD1'],
  ['#6F63A6', '#E2E0ED'],
  ['#D96C36', '#F8E2D6'],
  ['#00a698', '#CBEDEA'],
];

export const colorForStroke = (index: number, isShadow?: boolean): string => {
  return strokeColors[index % strokeColors.length]?.[
    isShadow ? 1 : 0
  ] as string;
};
